<template>
  <div class="concern-companies-count">
    <sn-header :title="'实时数据'">
      <div class="concern-companies-date">{{year}}年{{month}}月{{date}}日 {{day}} {{hour}}:{{minute}}:<span class="concern-companies-date-second">{{second}}</span></div>
    </sn-header>
    <div class="row concern-companies-news-count">
      <div class="concern-companies-news-count-item" v-for="(item, index) in data" :key="index">
        <div class="concern-companies-news-count-item-count">{{item.count}}</div>
        <div class="concern-companies-news-count-item-title">{{item.title}}</div>
        <div v-if="index!==3" class="concern-companies-news-count-item-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SnHeader from '@/components/common/SnHeader';

export default {
  props: {
    data: {
      type: Array
    },
    year: {
      typeof: Number
    },
    month: {
      typeof: Number
    },
    date: {
      typeof: Number
    },
    day: {
      typeof: Number
    },
    hour: {
      typeof: Number
    },
    minute: {
      typeof: Number
    },
    second: {
      typeof: Number
    }
  },
  components: {
    SnHeader
  }
};
</script>

<style lang="scss" scoped>
.concern-companies-count {
  width: 100%;
  height: 118px;
  background-color: #ffffff;
  .concern-companies-date {
    color: #747990;
    font-size: 12px;
    .concern-companies-date-second {
      display: inline-block;
      width: 16px;
    }
  }
  .concern-companies-news-count {
    &-item {
      position: relative;
      flex: 1;
      padding: 16px 0;
      &-count {
        color: #45a8cc;
        font-size: 20px;
        font-weight: 600;
        text-align: center;
      }
      &-title {
        color: #747990;
        font-size: 12px;
        text-align: center;
      }
      &-border {
        position: absolute;
        bottom: 29px;
        right: -2px;
        width: 2px;
        height: 12px;
        background-color: #45a8cc;
        opacity: 0.2;
      }
    }
  }
}
</style>
